
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M500 0C223.86 0 0 223.86 0 500s223.86 500 500 500 500-223.85 500-500S776.14 0 500 0zm.86 794.41c16.55-16.8 23.76-47.52 15.64-69.54-11.28-30.87-47.32-46-80.34-33.83s-50.78 47.06-39.4 77.84c7.71 21.1 31.68 37.07 54.26 40-71.22 11.75-167.74-5.69-287.89-76.45 61.16-58.43 57.38-112.23 99.34-188.3 60.54-109.6 221.21-89.59 238.86 7.12 128.26 33.92 121.45 190.35-.47 243.16zm94.83-241.21a275.77 275.77 0 00-105.17-94.73c-11.18-45.22 2.89-67.7 20.8-86.72A363.52 363.52 0 01679.8 523.48c-17.05 19.8-37.95 36.13-84.11 29.72zm237-266.77c-5.39 15.24-12 29.35-18.84 43.33s-14.27 27.34-22 40.52A889.14 889.14 0 01742 446q-17.32 23.65-35.92 46.15a402.62 402.62 0 00-166.3-149.89q20.46-20.76 42.07-40.49a891.62 891.62 0 0170.08-57.48c12.3-9 24.9-17.77 38-26.07s26.52-16.31 41.11-23.27a74 74 0 01101.61 91.48z"}})])
          )
        }
      }
    